<template>
  <b-modal id="taxInvoiceDetailModal" title="세금계산서 상세내역" size="xl" :no-enforce-focus="true" @show="fn_load" @hidden="fn_reset">

    <div v-if="invoiceInfo" class="modal_detail">

      <!-- 세금계산서 정보 -->
      <h3 class="section_title">세금계산서 정보</h3>
      <div class="table_list mb20">
        <table class="write">
          <colgroup>
            <col width="160">
            <col width="*">
            <col width="160">
            <col width="*">
          </colgroup>
          <tbody>
            <tr>
              <th><span>세금계산서번호</span></th>
              <td>{{ invoiceInfo.invoice_no }}</td>
              <th><span>발행일시</span></th>
              <td>{{ invoiceInfo.issue_dt }}</td>
            </tr>
            <tr>
              <th><span>한의원명</span></th>
              <td>{{ invoiceInfo.clinic_nm }}</td>
              <th><span>사업자번호</span></th>
              <td>{{ formatBizNumber(invoiceInfo.clinic_business_num) }}</td>
            </tr>
            <tr>
              <th><span>발행 구분</span></th>
              <td>
                <span :class="invoiceInfo.is_cancel ? 'badge_cancel' : 'badge_normal'">
                  {{ invoiceInfo.is_cancel ? '마이너스(취소)' : '정상' }}
                </span>
              </td>
              <th><span>발행완료 금액</span></th>
              <td>
                <strong :class="invoiceInfo.is_cancel ? 'color_red' : 'color_blue'">
                  {{ invoiceInfo.is_cancel ? '-' : '+' }}{{ fn_comma_won(invoiceInfo.issue_amt) }}원
                </strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 주문 내역 -->
      <h3 class="section_title mb10">발행 내역 주문 리스트</h3>
      <div class="table_list">
        <div class="order_scroll_area">
          <table class="list">
            <colgroup>
              <col width="130">
              <col width="*">
              <col width="90">
              <col width="90">
              <col width="120">
              <col width="120">
              <col width="120">
            </colgroup>
            <thead>
              <tr>
                <th>주문번호</th>
                <th>처방명</th>
                <th>처방의</th>
                <th>환자명</th>
                <th class="ar">무통장금액</th>
                <th class="ar">예치금금액</th>
                <th class="ar">합계금액</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="orderList.length === 0">
                <td colspan="7" class="ac"><span>주문 내역이 없습니다.</span></td>
              </tr>
              <tr v-for="order in pagedOrderList" :key="order.order_code">
                <td><span>{{ order.order_code }}</span></td>
                <td><span>{{ order.prescribe_nm }}</span></td>
                <td><span>{{ order.doctor_nm }}</span></td>
                <td><span>{{ order.patient_nm }}</span></td>
                <td class="ar"><span>{{ fn_comma_won(order.pay_price) }}</span></td>
                <td class="ar"><span>{{ fn_comma_won(order.deposit_used_price) }}</span></td>
                <td class="ar">
                  <span :class="invoiceInfo.is_cancel ? 'color_red' : 'color_blue'">
                    {{ fn_comma_won(order.real_amt) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <AdminPagination :pageInfo="orderPageInfo" @clickPage="fn_move_page" v-show="pagingShow" />
      </div>

    </div>

    <div v-else class="ac pt20 pb20">
      <span>데이터를 불러오는 중입니다.</span>
    </div>

    <template #modal-footer>
      <b-button class="btn btn_md btn_brown" @click="$bvModal.hide('taxInvoiceDetailModal')">확인</b-button>
    </template>

  </b-modal>
</template>

<script>
  import axios from 'axios'
  import commonUtil from '@/mixin/commonUtil'
  import AdminPagination from '@/components/AdminPagination.vue'

  export default {
    name: 'taxInvoiceDetailModal',
    components: { AdminPagination },
    mixins: [commonUtil],
    props: {
      detailData: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        invoiceInfo: null,
        orderList: [],
        orderPageInfo: { page: 1, pageSize: 10, totPage: 0 },
        pagingShow: false
      }
    },
    computed: {
      pagedOrderList() {
        return this.orderList
      }
    },
    methods: {
      fn_load() {
        if (!this.detailData) return
        this.invoiceInfo = { ...this.detailData }

        axios.post('/api/admin/settlement/getTaxInvoiceDetail', {
          invoice_no: this.detailData.invoice_no
        }).then(res => {
          this.orderList = res.data.orderList
          this.orderPageInfo.totPage = res.data.totCnt
          this.pagingShow = res.data.totCnt > this.orderPageInfo.pageSize
        }).catch(() => {
          // API 미연동 시 더미 데이터
          this.orderList = this.fn_dummy_orders()
          this.orderPageInfo.totPage = this.orderList.length
          this.pagingShow = false
        })
      },
      fn_dummy_orders() {
        const patients      = ['홍길동', '김철수', '이영희', '박민수', '정수연', '최진호', '강보람']
        const prescriptions = ['쌍화탕', '보중익기탕', '육군자탕', '십전대보탕', '갈근탕', '황기건중탕', '사물탕']
        const payUnits      = [60000, 90000, 104000, 76000, 122000, 54000, 86000]
        const depUnits      = [30000, 45000, 52000, 38000, 61000, 27000, 43000]
        return Array.from({ length: 5 }, (_, i) => ({
          order_code:         `ORD2026${String(i + 1).padStart(3, '0')}`,
          prescribe_nm:       prescriptions[i % prescriptions.length],
          doctor_nm:          this.invoiceInfo.clinic_nm ? '김한의' : '김한의',
          patient_nm:         patients[i % patients.length],
          pay_price:          payUnits[i % payUnits.length],
          deposit_used_price: depUnits[i % depUnits.length],
          real_amt:           payUnits[i % payUnits.length] + depUnits[i % depUnits.length]
        }))
      },
      fn_reset() {
        this.invoiceInfo  = null
        this.orderList    = []
        this.orderPageInfo = { page: 1, pageSize: 10, totPage: 0 }
        this.pagingShow   = false
      },
      fn_move_page(page) {
        this.orderPageInfo = { ...this.orderPageInfo, page }
        this.fn_load()
      }
    }
  }
</script>

<style scoped>
  .section_title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #262939;
    border-left: 3px solid #262939;
    padding-left: 10px;
    margin-bottom: 10px;
  }
  .mb10 { margin-bottom: 10px; }
  .mb20 { margin-bottom: 20px; }
  .pt20 { padding-top: 20px; }
  .pb20 { padding-bottom: 20px; }
  .ar   { text-align: right; }
  .ac   { text-align: center; }

  .color_blue { color: #2b6cb0; font-weight: 700; }
  .color_red  { color: #c53030; font-weight: 700; }

  .badge_normal {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 1.2rem;
    font-weight: 600;
    background: #ebf4ff;
    color: #2b6cb0;
  }
  .badge_cancel {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 1.2rem;
    font-weight: 600;
    background: #fff5f5;
    color: #c53030;
  }

  /* 스크롤 영역: 10행 + 헤더 */
  .order_scroll_area {
    max-height: 408px;
    overflow-y: auto;
    overflow-x: auto;
  }
  .order_scroll_area table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f5f6fa;
  }

  /* 모달 바디 하단 패딩 축소 */
  ::v-deep .modal-body { padding-bottom: 8px; }
  ::v-deep .pagination { margin: 4px 0 0; }
</style>